<script>
import RatingNote from "@/components/reviews/RatingNote.vue";
import BoutonFavorite from "@/components/products/viewProduct/BoutonFavorite.vue";
import BoutonCart from "@/components/products/viewProduct/BoutonCart.vue";
import {mapStores} from "pinia";
import {useAuthStore} from "@/stores/auth";

export default {
  name: 'InformationProduct',
  components: {BoutonCart, BoutonFavorite, RatingNote},
  props: {
    product: Object
  },
  computed: {
    ...mapStores(useAuthStore),
    numberOfReviews () {
      return this.product.Reviews ? this.product.Reviews.length : 0
    },
    getNote () {
      let note = 0
      Object.values(this.product.Reviews).map(review => {
        note += review.note
      })
      if (note > 0) {
        return (note / this.product.Reviews.length).toFixed(1)
      }
      return 0
    }
  }
}
</script>

<template>
<div>
  <div class="my-5">
    <router-link to="/boutique" class="flex items-center justify-start text-gray-400 hover:underline">
      <i class="fa-solid fa-chevron-left mt-1 mr-2"></i>
      retour produit
    </router-link>
  </div>
  <h1 class="text-4xl font-extrabold uppercase lg:text-4xl" :style="{'color': product.color}">
    <span class="uppercase lg:text-6xl">déglingo</span><br>{{ product.title }}
  </h1>
  <div v-if="product.category.tag === 'bouteilles' || product.category.tag === 'futs'" class="flex items-center mt-5">
    <div class="space-y-2 mr-5 text-center text-lg flex items-center">
      <i class="fa-solid fa-wine-bottle mr-2 mt-2"></i>
      <div>{{ product.cl }}cl</div>
    </div>
    <div class="space-y-2 text-center ml-5 text-lg flex items-center">
      <i class="fa-solid fa-percent mr-2 mt-2"></i>
      <div>{{ product.degres }}</div>
    </div>
  </div>
  <div class="mt-4 sm:items-center sm:gap-4 sm:flex">
    <p class="text-2xl font-extrabold text-gray-900 sm:text-3xl dark:text-white">
      {{ product.price }}€
    </p>
    <rating-note :note="getNote" :number-reviews="numberOfReviews"/>
  </div>

  <div class="mt-6 sm:gap-4 sm:items-center sm:flex sm:mt-8">
    <bouton-favorite :product="product" />
    <bouton-cart v-if="authStore.isConnected" :product="product" />
  </div>

  <hr class="my-6 md:my-8 border-gray-200 dark:border-gray-800" />

  <p class="mb-6 text-gray-500 dark:text-gray-400">
    {{ product.description }}
  </p>
  <div v-if="product.category.tag === 'bouteilles' || product.category.tag === 'futs'">
    <div>
      <h2 class="text-lg font-bold" :style="{'color': product.color}">COULEUR ET PRÉSENTATION</h2>
      <p class="text-sm mt-1 mb-5">
        {{ product.couleur }}
      </p>
    </div>
    <div>
      <h2 class="text-lg font-bold" :style="{'color': product.color}">NEZ</h2>
      <p class="text-sm mt-1 mb-5">
        {{ product.nez }}
      </p>
    </div>
    <div>
      <h2 class="text-lg font-bold" :style="{'color': product.color}">GOÛT</h2>
      <p class="text-sm mt-1 mb-5">
        {{ product.gout }}
      </p>
    </div>
  </div>
</div>
</template>
